import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationGalleryCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новый фото альбом</div>
            <div className={'vm-notification__description'}>
                В Togas Life добавлен новый альбом <UiNavLink to={ROUTES.GALLERY(notification.data.gallery.id)} onClick={onClose}>{notification.data.gallery.name}</UiNavLink>
            </div>
        </div>
    );
});
